export default __webpack_public_path__ + "static/media/svg-6.87b44220.svg";